import { Injectable } from '@angular/core';
import { PartNumberlist, UpdatedDealerSpecialTool } from '../business-entities/dealer-special-tool-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { DealerSpecialToolDataService } from '../data-services/dealer-special-tool-data.service';
import { DealerSpecialToolDetailsListViewModel } from './../business-entities/dealer-special-tool-details-view-model';
import { DealerSpecialTool } from './../business-entities/dealer-special-tool-view-model';
@Injectable({
  providedIn: 'root'
})

export class DealerSpecialToolBusinessService {
  dealerID: string;
  isEdit: boolean = false;
  selectedId: string;
  DealerSpecialToolId: number
  dealerSpecialToolList: DealerSpecialToolDetailsListViewModel;
  specialTool: DealerSpecialTool;
  partnumberList: PartNumberlist[];
  dealerList: Array<SelectListItemViewModel>;
  constructor(private service: DealerSpecialToolDataService) {
  }

  async getService(vehicalObj: any) {
    await this.service
      .getDealerSpecialToolList(vehicalObj)
      .then(
        (res: GenericResponse<DealerSpecialToolDetailsListViewModel>) => {
          this.dealerSpecialToolList = res.responseObject;
        }
      );

    return this.dealerSpecialToolList;
  }

  AssignDealerSpecialTool(model: any): Promise<GenericResponse<any>> {
    return this.service.AssignDealerSpecialTool(model);
  }

  async GetDealerSpecialToolById(Id: number,Language:string) {
    await this.service
      .getDealerSpecialToolById(Id,Language)
      .then(
        (res: GenericResponse<DealerSpecialTool>) => {
          this.specialTool = res.responseObject;
        }
      );
    return this.specialTool;
  }

  async GetDealerSpecialToolByBrandId(Id: number) {
    await this.service
      .GetDealerSpecialToolByBrandId(Id)
      .then(
        (res: GenericResponse<any>) => {
          this.partnumberList = res.responseObject;
        }
      );
    return this.partnumberList;
  }

  UpdateDealerSpecialTool(model: UpdatedDealerSpecialTool): Promise<GenericResponse<any>> {
    return this.service.UpdateDealerSpecialTool(model);
  }

  // getServiceCategory() {
  //     return this.service.getServiceCategory();
  // }

  // deleteService(Id: number) {
  //     return this.service.deleteService(Id);
  // }
}
